import { ActionTypes } from "./constants";

const initialState = {
  users: [],
};

const MgtUserReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_USERS:
      return { ...state, users: payload };
    case ActionTypes.ADD_USER:
      return { ...state, users: [...state.users, payload] };
    case ActionTypes.UPDATE_USER:
      return {
        ...state,
        users: state.users.map((item) =>
          item.id == payload.id ? payload : item
        ),
      };
    case ActionTypes.UPDATE_USER_IS_APPROVE:
      return {
        ...state,
        users: state.users.map((item) =>
          item.id == payload.id
            ? {
                ...item,
                is_approve: payload.is_approve,
                approve_date: payload.approve_date,
              }
            : item
        ),
      };
      case ActionTypes.DELETE_USER:
        return {
          ...state,
          users: state.users.filter(item=> item.id != payload.id)
        };
    default:
      return state;
  }
};

export default MgtUserReducer;
